import api from "./axiosInstance";

export function listCompanies({ trustedOnly = false, companyType } = {}) {
  const params = {};
  if (trustedOnly) params.trusted_only = true;
  if (companyType) params.company_type = companyType;
  return api.get("/companies", { params });
}

export function createCompany(payload) {
  return api.post("/companies", payload);
}

export function fetchCompany(companyId) {
  if (!companyId) {
    return Promise.reject(new Error("companyId is required"));
  }
  return api.get(`/companies/${companyId}`);
}
